/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable class-methods-use-this */
import * as Services from '@services';
import { makeAutoObservable, runInAction } from 'mobx';

class AddressStore {
  address: Services.AddressDto | undefined;
  postcodes: string[] = [];
  loadingPostcodes = false;

  constructor() {
    makeAutoObservable(this);
  }

  async getAddress(postcode: string) {
    const result = await Services.AddressService.getAddress(postcode);
    runInAction(() => {
      this.address = result;
    });
  }

  async getPostcodes(query: string) {
    this.setLoadingPostcodes(true);
    try {
      const result = await Services.AddressService.getPostcodes(query);
      runInAction(() => {
        this.postcodes = result;
      });
    } catch (error) {
      console.error('Error fetching postcodes:', error);
    } finally {
      this.setLoadingPostcodes(false);
    }
  }

  setLoadingPostcodes(loading: boolean) {
    runInAction(() => {
      this.loadingPostcodes = loading;
    });
  }

  clearPostcodes = () => {
    runInAction(() => {
      this.postcodes = [];
    });
  };

  clearAddress = () => {
    runInAction(() => {
      this.address = undefined;
    });
  };
}

export default AddressStore;
